// extracted by mini-css-extract-plugin
export default {"root":"TherapistMapList_root__pL-NX","title":"TherapistMapList_title__4-eOs","text":"TherapistMapList_text__pytad","item":"TherapistMapList_item__rhcNX"};